import { latlong2featurePoint, featureSetZoom } from '../geojson-utilities';

/**
 * Add a listener for moving actions. After a move, get the current map location
 * and update the project's location  and bounding box.
 *
 * @callback
 * @param {object} arg - The object argument.
 * @param {object} arg.leafletMap - The leaflet map to update.
 * @param {Function} arg.onLocationChange - The funcion that changes the project location on the parent.
 */
const moveProjectLocation = ({ leafletMap, onLocationChange }) => {
  leafletMap.on('moveend', () => {
    const currentLocation = latlong2featurePoint(leafletMap.getCenter().wrap());
    featureSetZoom(currentLocation, leafletMap.getZoom());
    const bboxString = leafletMap.getBounds().toBBoxString();
    // 'southwest_lng,southwest_lat,northeast_lng,northeast_lat' format
    const bboxStrings = bboxString.split(',');
    const bboxNumbers = bboxStrings.map(coordinate => Number(coordinate));
    onLocationChange(currentLocation, bboxNumbers);
  });
};

export default moveProjectLocation;
